import { Injectable } from '@angular/core';

import 'rxjs/add/operator/map';
import { AppConfig } from '../../config/app.config';

import { Storage } from '@ionic/storage';
import { Http, Headers } from '@angular/http';
import { Credentials } from './login';

@Injectable()
export class LoginProviderMock {

  constructor() {

  }

  public async login(credentials: Credentials): Promise<boolean> {
    return true;
  }

  async isLoggedIn(): Promise<boolean> {
    return true;
  }

  async getToken(): Promise<string> {
    return '';
  }

  public logout() {
    return;
  }
}


// WEBPACK FOOTER //
// ./src/providers/login/login-mock.ts